export default {
  // 七牛上传图片获取token
  getPicUploadToken: '/amc/client/getResourceUploadToken',
  // 七牛上传视频获取token
  getVideoUploadToken: '/amc/client/getStreamUploadToken',
  // 七牛上传图片后压缩图片接口
  imageCompression: '/amc/client/getPictureInfo',
  // 七牛上传视频后的压缩接口
  videoCompression: '/amc/client/getStreamAccessUrlByStreamId',
  
}